import React from "react";
import { useViewport } from 'components/general/useViewPort'
import { useState, useEffect } from "react";
import Label from "components/general/Label"
import Horse from "components/presentation/Horse";
import Competitor from "components/presentation/Competitor";
import { NocMemo as Noc } from "components/presentation/Noc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import SportCode from "components/common/SportCode";

export const JumpPreviousCurrent = (props) => {
    const { current, currentId, previous, previousId, efforts, type, settings, teamAfter } = props;
   
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';
    
    const effortsLength = !efforts || !Array.isArray(efforts) ? 0 : efforts.length; //to avoid blank page
    
    const config = settings ? settings : {};
    config.visible = !isNaN(config.visible) ? Number(config.visible) : effortsLength;
    config.step = !isNaN(config.step) ? Number(config.step) :  config.visible;
    config.visible = effortsLength > config.visible ? config.visible : effortsLength;
    config.showButtons = config.visible !== effortsLength
    config.type = type;

    const [cssPrevious, setCssPrevious] = useState('', ...Array(config.visible).fill('d-table-cell'), ...Array(effortsLength - config.visible).fill('d-none'));
    const [cssCurrent, setCssCurrent] = useState('', ...Array(config.visible).fill('d-table-cell'), ...Array(effortsLength - config.visible).fill('d-none'));

    const [indexPrevious, setIndexPrevious] = useState(config.visible);
    const [indexCurrent, setIndexCurrent] = useState(config.visible);

    useEffect(() => {
        let array_ = populateCssArray(efforts, config.visible, indexPrevious)
        setCssPrevious(array_);
    }, [indexPrevious])

    useEffect(() => {
        let array_ = populateCssArray(efforts, config.visible, indexCurrent)
        setCssCurrent(array_);
    }, [indexCurrent])

    // do nothing if there is NO efforts
    if (effortsLength === 0) {
        return <></>; 
    }

    const realPrevious = type === 'T' ? previous?.teamAthletes?.find(ta => ta?.athlete?.code === previousId) : previous;
    const realCurrent = type === 'T' ? current?.teamAthletes?.find(ta => ta?.athlete?.code === currentId) : current;
    
    const xlPrevious = <JumpingResultBoxXl result={realPrevious} efforts={efforts} config={config} index={indexPrevious} setIndex={setIndexPrevious} cssArray={cssPrevious} teamAfter={teamAfter} teamResult={previous}/>;

    const xsPrevious = <JumpingResultBoxXs result={realPrevious} efforts={efforts} config={config} index={indexPrevious} setIndex={setIndexPrevious} cssArray={cssPrevious} teamResult={previous}/>;

    const xlCurrent = <JumpingResultBoxXl result={realCurrent} efforts={efforts} config={config} index={indexCurrent} setIndex={setIndexCurrent} cssArray={cssCurrent} current={true}/>;

    const xsCurrent = <JumpingResultBoxXs result={realCurrent} efforts={efforts} config={config} index={indexCurrent} setIndex={setIndexCurrent} cssArray={cssCurrent} current={true}/>;
   
return <>
        { !realPrevious ? <></> : isMobile ? xsPrevious : xlPrevious }
        { !realCurrent  ? <></> : isMobile ? xsCurrent  : xlCurrent  }
    </>

}

const JumpingResultBoxXl = (props) => {
    const { result, efforts, config, current, index, setIndex, cssArray, teamAfter, teamResult } = props;
    //console.log(props);
    const competitorData = config?.type === 'T' ? result?.athlete : result?.participant;

    return (
        <table className="table table-sm table-bordered border">
            <caption><Label data={current ? 'HeaderCurrentComp': 'HeaderPreviousComp'}/></caption>
            <thead>
                <tr>
                    <th className="w-10 text-end fw-bold">{result?.startOrder}</th>
                    <th className="text-start fw-bold" colSpan={config.visible}>
                        <div className='d-flex align-items-center'>
                            <div className='d-none d-md-block me-1'>
                                <Noc className='me-1' {...competitorData?.organisation} />
                            </div>
                            <div>
                                <Competitor hidePicture={true} {...competitorData} />
                            </div> 
                            <div className="ms-4">
                               <Horse {...result?.horse}/>                                   
                            </div> 
                        </div>
                    </th>
                    {config.showButtons && <th></th>}
                    <th className="w-5 text-center"></th>
                    <th className="w-5 text-end">{ config?.type !== 'T' && <Time result={result}/> }</th>
                    <th className="w-5 text-end">{ config?.type !== 'T' && <Rank result={result}/> }</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start" ><Label data="HeaderFence" /></td>
                    <Fences efforts={efforts} config={config} index={index} setIndex={setIndex} cssArray={cssArray}/>
                    <td className="text-end fw-bold" ><Label data="HeaderJump" /></td>
                    <td className="text-end fw-bold" ><Label data="HeaderTime" /></td>
                    <td className="text-end fw-bold" ><Label data="HeaderTotal" /></td>
                </tr>
                <tr>
                    <td className="text-start" ><Label data="HeaderPenalty" /></td>
                    <Penalties efforts={efforts} result={result} config={config} current={current} cssArray={cssArray}/>
                    <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_J_PEN" config={config}/></td>
                    <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_T_PEN" config={config}/></td>
                    <td className="text-end"><IrmOrExtendedResultValue current={current} result={result} code="J_TOTAL_PEN" config={config}/></td>
                </tr>
                { config?.type === 'T' && !current &&
                    <>
                        <tr>
                            <td className="w-10 text-end fw-bold"></td>
                            <td className="text-center fw-bold" colSpan={config.visible}>{teamAfter && <Label data="LabelTeamResAfterComposed" values={{ teamAfter: teamAfter }} />}</td>
                            {config.showButtons && <td></td>}
                            <td className="w-5 text-center"></td>
                            <td className="w-5 text-end"></td>
                            <td className="w-5 text-end"></td>
                        </tr>
                        <tr>
                            <td className="w-10 text-end fw-bold"></td>
                            <td className="text-center fw-bold" colSpan={config.visible}></td>
                            {config.showButtons && <td></td>}
                            <td className="text-end fw-bold"><Label data="HeaderTotal" /></td>
                            <td className="text-end fw-bold"><Label data="HeaderTime" /></td>
                            <td className="text-end fw-bold"><Label data="HeaderRank" /></td>
                        </tr>
                        <tr>
                            <td className="w-10 text-end fw-bold"></td>
                            <td className="text-center fw-bold" colSpan={config.visible}>
                                <div className='d-flex align-items-center'>
                                    <div className='d-none d-md-block me-1'>
                                        <Noc className='me-1' {...teamResult?.participant?.organisation} />
                                    </div>
                                    <div>
                                        <Competitor hidePicture={true} {...teamResult?.participant} />
                                    </div>                                    
                                </div>
                            </td>
                            {config.showButtons && <td></td>}
                            <td className="text-end"><IrmOrExtendedResultValue result={teamResult} code="J_TOTAL_PEN"/></td>
                            <td className="text-end"><Time result={teamResult} hideLabel={true}/></td>
                            <td className="text-end"><Rank result={teamResult} hideLabel={true}/></td>
                        </tr>
                    </>
                }   
            </tbody>
        </table>
    );

}

const JumpingResultBoxXs = (props) => {
    const { result, efforts, config, current, index, setIndex, cssArray, teamResult } = props;
    const competitorData = config?.type === 'T' ? result?.athlete : result?.participant;


    let rowHeader
    if (current) {
        rowHeader = (
            <tr>
                <td colSpan={config.visible-1} className="text-start fw-bold"><Label data={current ? 'HeaderCurrentComp': 'HeaderPreviousComp'} /></td>
                <td className="text-end fw-bold"><Label data="HeaderJump" /></td>
                <td className="text-end fw-bold"><Label data="HeaderTime" /></td>
                <td className="text-end fw-bold"><Label data="HeaderTotal" /></td>
            </tr>
        );
    } else {
        rowHeader = (
            <>
                <tr>
                    <td colSpan={config.visible-2} rowSpan={2} className="text-start fw-bold"><Label data={current ? 'HeaderCurrentComp': 'HeaderPreviousComp'} /></td>
                    <td className="text-center fw-bold" colSpan={2}><Label data="HeaderPenalties2" /></td>
                    { config?.type !== 'T' &&
                    <>
                        <td className="text-end fw-bold" rowSpan={2}><Label data="HeaderTotal" /></td>
                        <td className="text-end fw-bold" rowSpan={2}><Label data="HeaderRank" /></td>
                    </>
                    }
                    { config?.type === 'T' &&
                    <>
                        <td className="text-end fw-bold" rowSpan={2} colSpan={2}><Label data="HeaderTotal" /></td>
                    </>
                    }
                </tr>
                <tr>
                    <td className="text-end fw-bold"><Label data="HeaderJump" /></td>
                    <td className="text-end fw-bold"><Label data="HeaderTime" /></td>
                </tr>
            </>    
        );

    }

    let rowResult
    if (current) {
        rowResult = (
            <tr>
                <td colSpan={config.visible-1} className="text-start"><Competitor {...competitorData} alwaysNoc={true} hidePicture={true}/> <Horse {...result?.horse}/></td>
                <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_J_PEN" config={config}/></td>
                <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_T_PEN" config={config}/></td>
                <td className="text-end"><IrmOrExtendedResultValue current={current} result={result} code="J_TOTAL_PEN" config={config}/></td>
            </tr>
        );
    } else {
        rowResult = (
            <>
                <tr>
                    <td colSpan={config.visible-2} className="text-start"><Competitor {...competitorData} alwaysNoc={true} hidePicture={true}/> <Horse {...result?.horse}/></td>
                    <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_J_PEN" config={config}/></td>
                    <td className="text-end"><ExtendedResultValue current={current} result={result} code="J_T_PEN" config={config}/></td>
                    { config?.type !== 'T' &&
                    <>
                        <td className="text-end"><IrmOrExtendedResultValue current={current} result={result} code="J_TOTAL_PEN" /></td>
                        <td className="text-end"><Rank result={result} hideLabel={true}/></td>
                    </>
                    }
                    { config?.type === 'T' &&
                    <>
                        <td className="text-end" colSpan={2}><IrmOrExtendedResultValue current={current} result={result} code="J_TOTAL_PEN" config={config}/></td>
                    </>
                    }

                </tr>
                { config?.type === 'T' &&
                    <tr>
                        <td colSpan={config.visible-2} className="text-start"><Competitor hidePicture={true} {...teamResult?.participant} alwaysNoc={true} /></td>
                        <td className="text-end"></td>
                        <td className="text-end"></td>
                        <td className="text-end"></td>
                        <td className="text-end"><IrmOrPenaltyRank result={teamResult} /></td>
                    </tr>
                }
            </>    
        );

    }
    return (
        <table className="table table-sm table-bordered border">
            <thead>
                {rowHeader}
            </thead>
            <tbody>
                {rowResult}
                <tr>
                    <td className="text-start" ><Label data="HeaderFence" /></td>
                    <Fences efforts={efforts} config={config} index={index} setIndex={setIndex} cssArray={cssArray}/>
                </tr>
                <tr>
                    <td className="text-start" ><Label data="HeaderPenalty" /></td>
                    <Penalties efforts={efforts} result={result} config={config} current={current} cssArray={cssArray}/>
                </tr>
            </tbody>
        </table>
    );

}

const Fences = (props) => {
    const {efforts, config, index, setIndex, cssArray} = props;
    const handleColumnDecrement = () => {
        let top = index - config.step;
        let bottom = top - config.visible;
        top = bottom < 0 ? config.visible : top;
        setIndex(top)
    }

    const handleColumnIncrement = () => {
        let top = index + config.step
        top = top >= efforts.length ? efforts.length : top;
        setIndex(top) 
    }

    const out = efforts?.map(eff => (
                        <td key={eff?.pos} className={`w-5 fw-bold ${cssArray[Number(eff?.pos)]}`}>
                            {eff?.value}
                        </td>
                    )
    );

    let buttons = <></>
    if (config.showButtons) {
        buttons = (
            <td className="w-5">
                <nav>
                    <button className='splits' onClick={() => handleColumnDecrement()}><FontAwesomeIcon className="font-icon" icon={faAngleLeft} /></button>
                    <button className='splits' onClick={() => handleColumnIncrement()}><FontAwesomeIcon className="font-icon" icon={faAngleRight} /></button>
                </nav>
            </td>

        );
    }

    return (<>{out}{buttons}</>)

}

const Penalties = (props) => {
    const {efforts, result, config, current, cssArray} = props;
    let extensions = config?.type === 'T' ? result?.extResults?.find(er => er?.er_code === 'EFFORTS')?.extensions : result?.extendedResults?.find(er => er?.er_code === 'EFFORTS')?.extensions;
    const out = efforts?.map(eff => (
            <td key={eff?.pos} className={`w-5 ${cssArray[Number(eff?.pos)]}`}>
                {extensions?.find(e => e?.ere_pos === eff?.pos && e?.ere_code === 'OUTCOME')?.ere_value}
            </td>
        )
    );
    const buttons = config.showButtons ? <td className="w-5"></td> : <></>;
    return (<>{out}{buttons}</>)

}

const Time = (props) => {
    const {result, config, hideLabel} = props;
    const time = config?.type === 'T' ? result?.extResults?.find(er => er?.er_code === 'J_TIME')?.er_value : result?.extendedResults?.find(er => er?.er_code === 'J_TIME')?.er_value;
    const label = hideLabel ? <></> : <><Label data="HeaderTime" /><br/></>;
    return time ? <>{label}{time}</> : <></>;
}

const Rank = (props) => {
    const {result, hideLabel} = props;
    const rank = result?.resultRank && result?.resultRankEqual === 'Y' ? '='+result?.resultRank : result?.resultRank;
    const label = hideLabel ? <></> : <><Label data="HeaderRank" /><br/></>;
    return rank ? <>{label}{rank}</> : <></>;
}

const ExtendedResultValue = (props) => {
    const {result, code, current, config} = props;
    let value;
    if (current) {
        value = config?.type === 'T' ? result?.extResultsCurrent?.find(er => er?.er_code === code)?.er_value : result?.extendedResultsCurrent?.find(er => er?.er_code === code)?.er_value;
    } else {
        value = config?.type === 'T' ? result?.extResults?.find(er => er?.er_code === code)?.er_value : result?.extendedResults?.find(er => er?.er_code === code)?.er_value;
    }
    return value;
}

const IrmOrExtendedResultValue = (props) => {
    const {result, code, current, config} = props;
    let value;
    if (current) {
        value = config?.type === 'T' ? result?.extResultsCurrent?.find(er => er?.er_code === code)?.er_value : result?.extendedResultsCurrent?.find(er => er?.er_code === code)?.er_value;
    } else {
        value = config?.type === 'T' ? result?.extResults?.find(er => er?.er_code === code)?.er_value : result?.extendedResults?.find(er => er?.er_code === code)?.er_value;
    }
    const irmCode =  result.resultIrm;
    const irm = irmCode ? <SportCode discipline='EQU' entity='@IRM' code={irmCode} abbr={true} isAddLegend={true} /> : undefined;
    return irm ? irm : value;

}
const IrmOrPenaltyRank = (props) => {
    const {result} = props;
    const rank = result?.resultRank && result?.resultRankEqual === 'Y' ? '='+result?.resultRank : result?.resultRank;
    const penalty = result?.extendedResults?.find(er => er?.er_code === 'J_TOTAL_PEN')?.er_value;
    const penaltyRank = rank && penalty ? `${penalty} (${rank})` : rank ?  `(${rank})` : penalty;
    const irmCode =  result.resultIrm;
    const irm = irmCode ? <SportCode discipline='EQU' entity='@IRM' code={irmCode} abbr={true} isAddLegend={true} /> : undefined;
    return irm ? irm : penaltyRank;

}

const populateCssArray = (efforts, visible, top) => {
    let cssArray = ['']
    efforts?.forEach((item, i) => {
        const pos = i + 1;
        const bottom = top - visible + 1;
        if ( bottom <= pos && pos <= top) {
            cssArray = [...cssArray, ...['d-table-cell']]
        } else {
            cssArray = [...cssArray, ...['d-none']]
        }
    })
    return cssArray
}
